import { HeaderText } from "@src/components/general/HeaderText";
import { Text } from "@src/components/general/Text";
import { VerticalFlexbox } from "@src/components/layout/Flexbox";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@src/components/ui/card";
import { CreditCard } from "lucide-react";

export const BillingPage = () => {
  return (
    <VerticalFlexbox gap="md" className="w-full px-4 py-6 md:px-8 md:py-8">
      <VerticalFlexbox gap="xs">
        <Text
          sizing="sm"
          fontWeight={500}
          appearance="subdued"
          className="uppercase tracking-widest"
        >
          Billing
        </Text>
        <HeaderText tag="h1">Revenue cycle</HeaderText>
      </VerticalFlexbox>
      <Card className="max-w-xl">
        <CardHeader>
          <VerticalFlexbox
            alignItems="center"
            justifyContent="center"
            className="mb-2 size-10 rounded-lg bg-muted text-muted-foreground"
          >
            <CreditCard className="size-5" />
          </VerticalFlexbox>
          <CardTitle>Coming soon</CardTitle>
          <CardDescription>
            Claim status, coding quality, and reimbursement trends will appear
            here.
          </CardDescription>
        </CardHeader>
        <CardContent />
      </Card>
    </VerticalFlexbox>
  );
};
